import "../styles/style-international.css";

// International
import IntlSectionOne from "./parts/section-one";
import IntlSectionTwo from "./parts/section-two";
import IntlSectionThree from "./parts/section-three";
import IntlSectionFour from "./parts/section-four";
import IntlSectionFive from "./parts/section-five";
import IntlSectionSix from "./parts/section-six";

const UKPricingIndex = () => {

    return (
        <div style={{ height: "100vh" }}>
            <IntlSectionOne />
            <IntlSectionTwo />
            <IntlSectionThree />
            <IntlSectionFour />
            <IntlSectionFive />
            <IntlSectionSix />
        </div>
    );
};

export default UKPricingIndex;
